module.exports = __webpack_public_path__ + "explore/Components/ExploreHeader/arrow.0039fc109d22c02c728620a7e9bca47d.svg";